import { render } from "./PartnerRequestSentPendingListItem.vue?vue&type=template&id=55a66de9&scoped=true&ts=true"
import script from "./PartnerRequestSentPendingListItem.vue?vue&type=script&lang=ts"
export * from "./PartnerRequestSentPendingListItem.vue?vue&type=script&lang=ts"

import "./PartnerRequestSentPendingListItem.vue?vue&type=style&index=0&id=55a66de9&lang=scss&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a66de9"]])

export default __exports__